import request from "./request";

export type LoginRequest = {
  email: string;
  password: string;
};

export type LoginResponse = {
  email: string;
  accesses: string[];
};
export function login(data: LoginRequest): Promise<LoginResponse> {
  return request("/auth/login", data);
}
